import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=ab848612&scoped=true&"
import script from "./ApplicantDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantDetail.vue?vue&type=style&index=0&id=ab848612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab848612",
  null
  
)

export default component.exports